// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CircleCheckBigIcon,
  ClockIcon,
  React,
  RefreshCwIcon,
  SaveIcon,
  TriangleAlertIcon,
  jsxRuntime,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const ProductAnalysisForm = ({ product: e = {}, onUpdate: t }) => {
  const [n, r] = React.useState((e == null ? undefined : e.analysis_status) || ""),
    [a, l] = React.useState((e == null ? undefined : e.analysis_result) || ""),
    [c, d] = React.useState(false),
    [f, h] = React.useState(null),
    [p, g] = React.useState(false),
    [y, v] = React.useState(""),
    j = [
      {
        value: "pending",
        label: "Pending",
        icon: ClockIcon,
        color: "text-yellow-500",
      },
      {
        value: "completed",
        label: "Completed",
        icon: CircleCheckBigIcon,
        color: "text-green-500",
      },
    ],
    N = (O) => {
      (r(O), g(false), v(""));
    },
    b = (O) => {
      (l(O.target.value), g(false), v(""));
    },
    S = async () => {
      if (!e || !e.id) {
        h("Invalid product: Missing product ID");
        return;
      }
      (d(true), h(null), g(false), v(""));
      try {
        const O = {
            analysis_status: n,
            analysis_result: a,
          },
          _ = await api.put(`/admin/products/${e.id}/analysis`, O);
        if (
          (_.data && _.data.message ? v(_.data.message) : v("Analysis status updated successfully"),
          g(true),
          t && typeof t == "function")
        ) {
          const C = {
            ...e,
            analysis_status: n,
            analysis_result: a,
          };
          t(C);
        }
      } catch (O) {
        (console.error("Error updating analysis status:", O),
          h("Failed to update analysis status. Please try again."));
      } finally {
        d(false);
      }
    };
  return !e || typeof e != "object" ? (
    <div className={"bg-white rounded-xl shadow-sm p-6"}>
      <div className={"flex items-center space-x-3 text-yellow-500"}>
        <TriangleAlertIcon className={"h-5 w-5"} />
        <p className={"text-sm font-medium"}>
          {"No valid product data available for analysis. Please select a product first."}
        </p>
      </div>
    </div>
  ) : (
    <div className={"space-y-4"}>
      {f && (
        <div className={"mb-4 bg-red-50 border-l-4 border-red-400 p-4 rounded-md"} role={"alert"}>
          <div className={"flex"}>
            <div className={"flex-shrink-0"}>
              <TriangleAlertIcon className={"h-5 w-5 text-red-400"} />
            </div>
            <div className={"ml-3"}>
              <p className={"text-sm text-red-700"}>{f}</p>
            </div>
          </div>
        </div>
      )}
      {p && (
        <div
          className={"mb-4 bg-green-50 border-l-4 border-green-400 p-4 rounded-md"}
          role={"alert"}
        >
          <div className={"flex"}>
            <div className={"flex-shrink-0"}>
              <CircleCheckBigIcon className={"h-5 w-5 text-green-400"} />
            </div>
            <div className={"ml-3"}>
              <p className={"text-sm text-green-700"}>{y}</p>
            </div>
          </div>
        </div>
      )}
      <div className={"space-y-4"}>
        <div>
          <label className={"block text-sm font-medium text-gray-700 mb-3"}>
            {"Quick Status Update"}
          </label>
          <div className={"flex space-x-3"}>
            <button
              type={"button"}
              onClick={() => N("completed")}
              className={`flex items-center px-4 py-2 rounded-lg border transition-colors ${n === "completed" ? "bg-green-50 border-green-300 ring-2 ring-green-200 text-green-700" : "border-gray-200 hover:bg-green-50 text-gray-700"}`}
            >
              <CircleCheckBigIcon className={"h-5 w-5 mr-2 text-green-500"} />
              <span className={"font-medium"}>{"Completed"}</span>
            </button>
            <button
              type={"button"}
              onClick={() => N("pending")}
              className={`flex items-center px-4 py-2 rounded-lg border transition-colors ${n === "pending" ? "bg-yellow-50 border-yellow-300 ring-2 ring-yellow-200 text-yellow-700" : "border-gray-200 hover:bg-yellow-50 text-gray-700"}`}
            >
              <ClockIcon className={"h-5 w-5 mr-2 text-yellow-500"} />
              <span className={"font-medium"}>{"Pending"}</span>
            </button>
          </div>
        </div>
        <div>
          <label
            htmlFor={"analysis-status"}
            className={"block text-sm font-medium text-gray-700 mb-1"}
          >
            {"Analysis Status"}
          </label>
          <select
            id={"analysis-status"}
            className={
              "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
            }
            value={n}
            onChange={(O) => N(O.target.value)}
          >
            <option value={""}>{"Select Status"}</option>
            {j.map((O) => (
              <option key={O.value} value={O.value}>
                {O.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label
            htmlFor={"analysis-result"}
            className={"block text-sm font-medium text-gray-700 mb-1"}
          >
            {"Analysis Result"}
          </label>
          <textarea
            id={"analysis-result"}
            rows={"4"}
            className={
              "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
            }
            placeholder={"Enter analysis result..."}
            value={a}
            onChange={b}
          />
        </div>
        <div className={"flex justify-end"}>
          <button
            type={"button"}
            className={
              "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
            }
            onClick={S}
            disabled={c}
          >
            {c ? (
              <jsxRuntime.Fragment>
                <RefreshCwIcon className={"h-5 w-5 mr-2 animate-spin"} />
                {"Updating..."}
              </jsxRuntime.Fragment>
            ) : (
              <jsxRuntime.Fragment>
                <SaveIcon className={"h-5 w-5 mr-2"} />
                {"Update Status"}
              </jsxRuntime.Fragment>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
export { ProductAnalysisForm };
